import PlisteProduktZeit from "@/entities/common/pliste_produkt_zeit"
import ProdukteLogic from "@/logic/produkte_logic"
import Formatter from "../formatter"
import PreislisteZeitraumRequest from "@/entities/common/request/preisliste_zeitpunkt_request"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import MainLogic from "../main_logic"
import BstlArtikel from "@/entities/common/bstl_artikel"

export default class ShoppingLieferungLogic extends ProdukteLogic {

  get hasMindestbestellwert() {
    return this.mainLogic.bestellungPending.lieferung.mindestbestellwert != 0
  }

  get mindestbestellwert() {
    return this.mainLogic.bestellungPending.lieferung.mindestbestellwert
  }

  get kostenlosAb() {
    return this.mainLogic.bestellungPending.lieferung.kostenlosAb
  }

  private _warenkorb: BstlArtikel[]

  get warenkorb() {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    // return this._warenkorb.length > 0

    var warenkorbpreis = Formatter.berechnePreisListe(this.warenkorb)
    if (warenkorbpreis - this.mindestbestellwert >= 0) return true
    return false
  }

  init() {
    var bestellungPending = this.mainLogic.bestellungPending
    this._warenkorb = this.mainLogic.bestellungPending.artikelliste
    this.mainLogic.bestellungPendingListeners.push(() => {
      this._warenkorb = this.mainLogic.bestellungPending.artikelliste
    })
    
    var datum = bestellungPending.lieferung.gewaehlteUhrzeit

    var request = new PreislisteZeitraumRequest()
    request.filialeId = MainLogic.getInstance().filiale.filialeId
    request.zeitpunkt = datum

    this.loadError = false

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.preisliste = response.data.payload
          this.created = true
          if (this.createdListener) {
            this.createdListener()
          }
        } else {
          this.loadError = true
        }
      })
      .catch(() => {
        this.loadError = true
      })
  }
}
